module.exports = __webpack_public_path__ + "img/The ethereal peregrination.984ad333.webp";